import { render, staticRenderFns } from "./collectionCode.vue?vue&type=template&id=6050d610&"
import script from "./collectionCode.vue?vue&type=script&lang=ts&"
export * from "./collectionCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports